import { Box, Details, useOpenClose } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

export const HardwareLookupProcessed = ({ event }: { event: any }) => {
  const { isOpen, handleToggle } = useOpenClose();
  const capitalizedHardwareType = event?.data?.hardwareType
    ? event.data.hardwareType.charAt(0).toUpperCase() + event.data.hardwareType.slice(1)
    : 'Hardware';

  return (
    <Box flex="auto">
      <Box display="block">
        <Details isOpen={isOpen}>
          <Details.Summary isDetailsOpen={isOpen} onToggle={handleToggle} display="inline">
            <Box as="span" display="inline-block" margin="0 2xs 0 0">
              <EventBy event={event} /> Processed {capitalizedHardwareType} Lookup
            </Box>
          </Details.Summary>
          <Box margin="md 0" padding="md 0" childGap="sm" overflow="auto" maxHeight="400px" background="primary">
            <pre>
              <code>{JSON.stringify(event.data.lookupDetails, null, 2)}</code>
            </pre>
          </Box>
        </Details>
      </Box>
    </Box>
  );
};
